import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        tasklistTemplate: '=',
        departments: '=',
        roles: '=',
        levels: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ vm.tasklistTemplate.name }}</h1>
        </div>
        <manage-settings-tasklist-templates-form
            form="vm.form"
            tasklist-template="vm.tasklistTemplate"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
        />
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(
            this.tasklistTemplate,
            model => model.$update({ id: model.id, expand: 'templateTasks' })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/tasklist/templates/edit/index.js